<template>
	<div class="col-12" >
		<!-- <complete-loading :pageloader_value="pageLoader"  v-if="pageLoader"></complete-loading> -->
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <!-- v-if="parseInt(get_user.verified_status) == 1" -->
     <div class="mobileScroll">
    	<div class="fxviewWalletOuter walletcard">
    		
				<div class="fxviewWallet whiteBG border-radius" v-for="(list,key) in walletAccount"  v-if="Object.keys(walletAccount).length > 0">
	        		<div class="walletbalace mb-4">
	        			<div class="  mb-4">
	        				<div class="currency d-flex align-items-center mb-2">
								<div class=" mr-1">
									<img :src="'../../../../static/fxView/images/'+list.wallet.currency.toLowerCase()+'.svg'" width="26" class="mr-2 rounded-circle" alt="currency">
								</div>
								<div class="curType">
									<span>{{$t('Wal_detail_Wallet_ID')}}</span>
									<h6>{{list.wallet.wallet_no}}</h6>
								</div>
							</div>
							<div class="amount w-100 w-100 d-flex align-items-center">
								<span class="mb-0">{{$t('Wal_detail_availAmount')}}</span>
								<h5> {{list.margin_detail.AMOUNT}}</h5>
							</div> 
	        			</div> 
					</div>  
					<div class="walletlinks d-flex align-items-center justify-content-between">
						<a class="quickLinks d-flex align-items-center" href="#" @click.prevent="$parent.tab = 1; $parent.walletId = key; trackFzEvent('Deposit')" v-if="checkROll('deposits')">
							{{$t('Wal_detail_Deposit')}}
						</a>
			    		<a class="quickLinks d-flex align-items-center" href="#" @click.prevent="$parent.tab = 2; $parent.walletId = key; trackFzEvent('Withrawals')" v-if="checkROll('withdrawals')">
				    		{{$t('Wal_detail_Withdraw')}}
				    	</a>
			    		<a class="quickLinks d-flex align-items-center" href="#" @click.prevent="$parent.tab = 3; $parent.walletId = key">
			    			{{$t('Wal_detail_Transfer')}}
			    		</a>
					</div>
	        	 </div>
	        	 <!-- add new wallet -->
	        	 <div class="addnewWallet fxviewWallet" @click.prevent="showWalletForm = !showWalletForm" v-if="(Object.keys(walletAccount).length == 0) || (Object.keys(walletAccount).length > 0 && Object.keys(walletAccount).length <  4)"> 
	    	 		<feather type="plus" class="addnew"></feather> {{$t('Wal_detail_Add_New')}} 
	            </div>
        	</div>
            <div class=" modal-popup " v-if="showWalletForm">
            	<div class="row w-100 justify-content-center align-items-center"  v-if="parseInt(get_user.verified_status) >= 1">
                    <div class=" mb-3  middleBox">
                    	<div class="customPp">
                            <button @click.prevent="showWalletForm = false" type="button" class="close d-flex align-items-center justify-content-center" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    	<div class="whiteBG px-4 py-5">
	                        <div class="slctcurrency">
	                            <h4 class="mb-3"> {{$t('withdrawList_currency')}}</h4> 
	                            <input type="hidden" v-model="select_currency" v-validate="'required'" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('select_currency') }" ref="select_currencyInput" name="select_currency">
	                            <ul>
	                                <li :class="(select_currency == 'USD')?'selected':'' || (walletCurrencyData.includes('USD')? 'disabled' : '')" @click.prevent="select_currency = 'USD'">
	                                    <img src="../../../../static/fxView/images/usd.svg" alt="usd">
	                                     {{$t('createzullu_USD')}}
	                                </li>
	                                <li :class="(select_currency == 'EUR')?'selected':''  || (walletCurrencyData.includes('EUR')? 'disabled' : '')" @click.prevent="select_currency = 'EUR'">
	                                    <img src="../../../../static/fxView/images/eur.svg" alt="eur">
	                                     {{$t('createzullu_EUR')}}
	                                </li>
	                                <li :class="(select_currency == 'GBP')?'selected':''  || (walletCurrencyData.includes('GBP')? 'disabled' : '')" @click.prevent="select_currency =  'GBP'">
	                                    <img src="../../../../static/fxView/images/gbp.svg" alt="gbp">
	                                     {{$t('createzullu_GBP')}}
	                                </li>
	                                <li :class="(select_currency == 'AUD')?'selected':''  || (walletCurrencyData.includes('AUD')? 'disabled' : '')" @click.prevent="select_currency = 'AUD'">
	                                    <img src="../../../../static/fxView/images/aud.svg" alt="aud">
	                                     {{$t('createzullu_AUD')}}
	                                </li>
	                                <li :class="(select_currency == 'ZAR')?'selected':''  || (walletCurrencyData.includes('ZAR')? 'disabled' : '')" @click.prevent="select_currency = 'ZAR'">
	                                    <img src="../../../../static/fxView/images/zar.svg" class="rounded-circle" alt="zar">
	                                     {{$t('createzullu_ZAR')}}
	                                </li>
									<li :class="(select_currency == 'CAD')?'selected':''  || (walletCurrencyData.includes('CAD')? 'disabled' : '')" @click.prevent="select_currency = 'CAD'">
	                                    <img src="../../../../static/fxView/images/cad.svg" alt="CAD">
	                                     CAD
	                                </li>
	                            </ul> 
	                            <ul v-if="errors.first('select_currency')"><li class="error">{{$t('Wal_detail_curr_required')}}</li></ul>
	                        </div>
	                       
		                    <div class="full-width submitButton justify-content-center align-items-center  d-flex  mt-3 w-100">
		                        <button class="prism_btn btn_sm" v-on:click.prevent="submit()"> {{$t('Wal_detail_Submit')}}</button>
		                    </div>
	                    </div>
	                </div>
                </div>
                <div class="row w-100 justify-content-center align-items-center"  v-else>
                    <div class=" mb-3  middleBox">
                    	<div class="customPp">
                            <button @click.prevent="showWalletForm = false" type="button" class="close d-flex align-items-center justify-content-center" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
            			<no-trading-account :demo_live_both="'w/l'" :totalRecords = "'0'" ></no-trading-account>
            		</div>
            	</div>
            </div>
    	</div> 

    	<div class="row"> 
	        <div class="col-12 mt-4">
	        	<div class="showDeposiList w-100 mb-md-5">
                	<h2 class="mb-3">{{$t('Wal_detail_Trans_History')}} </h2>
                	<div class="inMiddle-area table-responsive">
		                <table class="table pmmTable">
		                    <thead>
		                        <tr>
									<th>{{$t('Wal_detail_Date')}}</th>
									<th>{{$t('Wal_detail_Time')}}</th>
									<th>{{$t('Wal_detail_Type')}}</th>
									<th>{{$t('Wal_detail_From')}}</th>
									<th> {{$t('Wal_detail_To')}} </th>
									<th>{{$t('Wal_detail_Amount')}}</th>
									<th>{{$t('Wal_detail_Status')}}</th>
		                        </tr>
		                    </thead>
		                    <tbody v-if="(!pageLoader && Object.keys(walletTransaction).length > 0 && walletTransaction.totalRecords > 0)">
		                        <tr v-for="list in walletTransaction.records" >
									<td>{{list.created | moment("DD MMMM YYYY")}} </td>
									<td>{{transactionTime(list.created)}}</td>
									<td>
										<p v-if="parseInt(list.transaction_method) == 4 || parseInt(list.transaction_method) == 15 || parseInt(list.transaction_method) == 16">{{$t('Wal_detail_Transfer')}} </p>
										<p v-else>{{$env_var.wallet_transaction_type[parseInt(list.transaction_type)]}} </p> 
									</td>
		                            <td>
		                            	<span v-if="parseInt(list.transaction_method) == 16">
		                            		{{list.wallet_no}}
		                            	</span>
		                            	<span v-else-if="parseInt(list.transaction_method) == 15">
		                            		{{$t('Wallet_Loyalty_Points')}}
		                            	</span>
		                            	<span v-else-if="parseInt(list.transaction_method) == 4">
		                            		<p v-if="parseInt(list.transaction_type) == 1">{{list.account_id}} </p>
		                            		<p v-else>{{list.wallet_no}} </p>
		                            	</span>
		                            	<span v-else>
		                            		<p v-if="parseInt(list.transaction_type) == 1">{{$env_var.depositMethod[list.transaction_method.toString()]}} </p>
		                            		<p v-else>{{list.wallet_no}} </p>
		                            	</span>
		                            </td>
		                            <td>
		                            	<span v-if="parseInt(list.transaction_method) == 16">
		                            		{{list.second_wallet_no}}
		                            	</span>
		                            	<span v-else-if="parseInt(list.transaction_method) == 15">
		                            		{{list.wallet_no}}
		                            	</span>
		                            	<span v-else-if="parseInt(list.transaction_method) == 4">
		                            		<p v-if="parseInt(list.transaction_type) == 1">{{list.wallet_no}} </p>
		                            		<p v-else>{{list.account_id}} </p>
		                            	</span>
		                            	<span v-else>
		                            		<p v-if="parseInt(list.transaction_type) == 1">{{list.wallet_no}} </p>
		                            		<p v-else>{{$env_var.depositMethod[list.transaction_method.toString()]}} </p>
		                            	</span>
		                            </td>
		                            <td>{{list.amount}} {{list.currency}}</td>
		                            <td>
		                            	<span class="alert alert-success">{{$env_var.wallet_transaction_status[parseInt(list.status)]}}</span>
		                            </td>
		                        </tr>
		                    </tbody>
		                    <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="'6'" :list="walletTransaction" v-else-if="!pageLoader "></loader-component>
		                </table>
		                <pagination :getList="walletTransaction" :limit="pageLimit" v-if="walletTransaction.totalRecords > 0"></pagination>
		            </div>
                </div>

	        </div>
    	</div>
	 
    	<!-- <no-trading-account :demo_live_both="''" :totalRecords = "'0'" v-else></no-trading-account> -->
    </div>
</template>
<script>
	import moment from 'moment'
    export default {
        name: 'Wallet',
        data() {
            return {
                response_msg : '',
                msg_type : '',
                pageLoader : false,
               	loaderFuncRun : '1',
                select_currency : '',
                showWalletForm : false,
                submitted : false,

                pageLimit : '10',
                search : '',
                page : '1', 
                offset :'',
                timezone :[
                    {offset: 720 ,text:'UTC -12', val:'-12'},
                    {offset: 660 ,text:'UTC -11', val:'-11'},
                    {offset: 600 ,text:'UTC -10', val:'-10'},
                    {offset: 540 ,text:'UTC -9', val:'-9'},
                    {offset: 480 ,text:'UTC -8', val:'-8'},
                    {offset: 420 ,text:'UTC -7', val:'-7'},
                    {offset: 360 ,text:'UTC -6', val:'-6'},
                    {offset: 300 ,text:'UTC -5', val:'-5'},
                    {offset: 240 ,text:'UTC -4', val:'-4'},
                    {offset: 180 ,text:'UTC -3', val:'-3'},
                    {offset: 120 ,text:'UTC -2', val:'-2'},
                    {offset: 60 ,text:'UTC -1', val:'-1'},
                    {offset: 0 ,text:'UTC', val:'0'},
                    {offset: -60 ,text:'UTC +1', val:'+1'},
                    {offset: -120 ,text:'UTC +2', val:'+2'},
                    {offset: -180 ,text:'UTC +3', val:'+3'},
                    {offset: -210 ,text:'UTC +3:30', val:'+3.5'},
                    {offset: -240 ,text:'UTC +4', val:'+4'},
                    {offset: -270 ,text:'UTC +4:30', val:'+4.5'},
                    {offset: -300 ,text:'UTC +5', val:'+5'},
                    {offset: -330 ,text:'UTC +5:30', val:'+5.5'},
                    {offset: -345 ,text:'UTC +5:45', val:'+5.75'},
                    {offset: -360 ,text:'UTC +6', val:'+6'},
                    {offset: -420 ,text:'UTC +7', val:'+7'},
                    {offset: -480 ,text:'UTC +8', val:'+8'},
                    {offset: -540 ,text:'UTC +9', val:'+9'},
                    {offset: -570 ,text:'UTC +9:30', val:'+9.5'},
                    {offset: -600 ,text:'UTC +10', val:'+10'},
                    {offset: -630 ,text:'UTC +10:30', val:'+10.5'},
                    {offset: -660 ,text:'UTC +11', val:'+11'},
                    {offset: -720 ,text:'UTC +12', val:'+12'},
                    {offset: -780 ,text:'UTC +13', val:'+13'},
                    {offset: -840 ,text:'UTC +14', val:'+14'},
                ],
            }
        },
		methods:{
			reset(){
				this.select_currency = ''
                this.showWalletForm = false
                this.submitted = false
				this.pageLoader = false
			},
			transactionTime(gettime){
				let d = new Date(gettime);
                let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
                let nd = new Date(utc + (3600000*this.offset));
                return moment(nd).format('hh:mm a')

			},
            submit(){
            	 const _that = this
            	 this.pageLoader = true
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                       let accountJson={
		                    'globalParams' : {
		                        'currency' :_that.select_currency,
		                        'account_type' : 'ECN',
		                        'platform' : 'ACT',
		                        'leverage' : '100',
		                        'password' : 'Abc@123',
		                        'demo_live' : '1',
		                        'is_wallet' :1
		                    },
		                    'localParams' : {'parameter' : _that}
		                }
		                _that._runCreateWalletAccount(accountJson)
                    }else{
						_that.pageLoader = false;
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            listing(){
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,'localParams' : {'parameter' : this}
                }
                this._runGetWalletTransaction(inputJson)
            },
			trackFzEvent(eventName){
				switch(eventName){
					case 'Deposit': 
						this.$trackEvent('CP+Wallet+Deposit');
					break;
					case 'Withrawals':
                        this.$trackEvent('CP+Wallet+Withdrawal');
					break;
                }
			}
		},
		created(){
			if(Object.keys(this.walletAccount).length > 0){
                this.loaderFuncRun = '0'
            }
            this._runGetWalletDetail({'globalParams' : {},'localParams' : {'parameter' : this,'loaderFuncRun': this.loaderFuncRun}})

            let time = this.timezone.filter(list=>list.offset == new Date().getTimezoneOffset())
			this.offset = (time.length)?time[0].val:''
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/wallet_detail.vue